





























































































import Vue from 'vue';
import { Component } from 'vue-property-decorator';
import { mapActions } from 'vuex';

@Component<ChangePassword>({
  methods: {
    ...mapActions('staff', ['fetchCurrentStaff']),
  },
})
export default class ChangePassword extends Vue {
  token = '';

  success = false;

  password = {
    value: '',
    confirm: '',
  };

  fetchCurrentStaff!: () => Promise<void>;

  mounted() {
    this.token = localStorage.getItem('token@forgot-password');
    if (!this.token) {
      this.$router.push('/forgot-password/otp-challenge');
    }
  }

  async save(): Promise<void> {
    try {
      await this.$http.post('/authentication/staff/reset-password', {
        token: this.token,
        password: this.password.value,
      });
      await this.fetchCurrentStaff();
      await this.$cheeers.notify({
        lang: 'forgotPassword.successfullyUpdated',
      });
      this.success = true;
    } catch (e) {
      await this.$cheeers.notify({
        lang: 'forgotPassword.failedToUpdated',
        type: 'error',
      });
      this.$router.push('/forgot-password');
    }
  }
}
